import { render, staticRenderFns } from "./SentimentTrends.vue?vue&type=template&id=80958dda&scoped=true"
import script from "./SentimentTrends.vue?vue&type=script&lang=js"
export * from "./SentimentTrends.vue?vue&type=script&lang=js"
import style0 from "./SentimentTrends.vue?vue&type=style&index=0&id=80958dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80958dda",
  null
  
)

export default component.exports